import React, { Component } from 'react';
import { stopPropagation } from 'helpers';

export default class AdditionNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  static getDerivedStateFromProps(nextProps) {
    const additionalMenu = nextProps.user.getAditionalMenu();
    return {additionalMenu};
  }

  componentWillUnmount() {
    document.removeEventListener('click', this._closeMenu);
  }

  _goTo = link => {
    const {user, location} = this.props;

    return () => {
      const prevLink = location.pathname + location.hash;

      this.setState({isOpen: false}, () => {
        if (prevLink !== link) {
          user.goTo(link);
        } else {
          window.location.reload();
        }
      });
    };
  };

  _getLinks = () => {
    const {additionalMenu} = this.state;
    const {user, location} = this.props;

    if (!user.getActiveRole()) return [];
    if (user.isInspector() && !user.isManufacturerSelected()) return [];
    if (!additionalMenu) return [];

    return additionalMenu[user.getRoleName()].map((menu, index) => {
      let isSelected = location.pathname === menu.link;

      return (
        <div
          key={index + 1}
          onClick={this._goTo(menu.link)}
          className={`additional-menu-item ${menu.index === 1 ? 'new' : ''} ${isSelected ? 'active' : ''}`}
        >
          {menu.name}
        </div>
      );
    });
  };

  _openMenu = event => {
    stopPropagation(event);

    document.addEventListener('click', this._closeMenu);

    this.setState(prevState => ({isOpen: !prevState.isOpen}));
  };

  _closeMenu = event => {
    stopPropagation(event);

    document.removeEventListener('click', this._closeMenu);

    this.setState({isOpen: false});
  };

  _getMenuClass = isEmpty => {
    const {isOpen} = this.state;

    if (!isEmpty || isOpen === undefined) return '';

    return isOpen ? 'additional-navigation-open' : 'additional-navigation-close';
  };

  render() {
    const links = this._getLinks();

    return (
      <div className='additional-navigation-wrapper'>
        {!!links.length &&
        <div className='menu-button' onClick={this._openMenu} />}
        <nav className={`additional-navigation ${this._getMenuClass(links.length)}`}>
          {links}
        </nav>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Routing/Header/AdditionNavigation.jsx